import { makeStyles, Typography, TypographyVariant } from "@material-ui/core"
import React from "react"
import { useTranslation } from "react-i18next"
import { TypographyColor } from "./InformationBar"

const useStyles = makeStyles(theme => ({
  detailInfo: {
    marginRight: theme.spacing(2),
    cursor: (props: { hasLink: boolean }) =>
      props.hasLink ? "pointer" : "default",
    color: (props: { hasLink: boolean }) =>
      props.hasLink ? theme.palette.primary.dark : "inherit",
    fontWeight: (props: { hasLink: boolean }) =>
      props.hasLink ? 500 : "normal"
  }
}))

type FormatterType = (value: any) => any
// !TODO rewrite to use ReactComponent
export type barItem = {
  title: string
  value?: number | string | null
  formatter?: FormatterType
  color?: TypographyColor
  variant?: TypographyVariant
  hasLink?: boolean
  goBack?: boolean
  pathToNavigate?: string
  onClick?: () => void
}

const BarItem = ({
  title,
  value,
  formatter = (value: number | string) => value,
  color = "textSecondary",
  variant = "caption",
  hasLink = false,
  goBack = true,
  onClick
}: barItem) => {
  if (value === null || value === undefined) value = "-"
  const { t } = useTranslation()
  const classes = useStyles({ hasLink })

  return (
    <>
      <Typography variant={variant} color={color}>
        {`${t(title)}:`}
      </Typography>
      <Typography
        variant={variant}
        color={color}
        style={{ marginRight: "10px", marginLeft: "2px" }}
        className={hasLink ? classes.detailInfo : ""}
        onClick={hasLink ? onClick : undefined}
      >
        {formatter(value)}
      </Typography>
    </>
  )
}

export type ValueItemType = {
  value?: number | string | null
  formatter?: FormatterType
  color?: TypographyColor
  variant?: TypographyVariant
  hasLink?: boolean
  goBack?: boolean
  pathToNavigate?: string
  onClick?: () => void
}

export const ValueItem = ({
  value,
  formatter = (value: number | string) => value,
  color = "textSecondary",
  variant = "caption",
  hasLink = false,
  onClick
}: ValueItemType) => {
  if (value === null || value === undefined) value = "-"
  const classes = useStyles({ hasLink })
  return (
    <Typography
      {...{
        variant,
        color,
        className: classes.detailInfo,
        onClick: hasLink ? onClick : undefined
      }}
    >
      {formatter(value)}
    </Typography>
  )
}

export default BarItem
